import AuthSubNav from './AuthSubNav.component';
export default AuthSubNav;